import styled from "@emotion/styled";
import { Grid, Card, CardHeader, CardContent, useTheme } from "@mui/material";

import { BasicFlex } from "../../../utils/Common";

import { useQuery } from "@tanstack/react-query";

import { getTicketById } from "../apiService";

import Dialog from "../../../utils/utilities/Dialog";

import MainRepairView from "../Tabs/MainRepair";

const ViewRepairDialog = ({ ticket, open, setOpen, setSelectedTicket, dash = false }) => {
  const theme = useTheme();
  let { repair_ticket_id } = ticket || {}

  const { data: repair_ticket } = useQuery({
    queryKey: ["repair_tickets", repair_ticket_id],
    queryFn: () => getTicketById(repair_ticket_id),
    enabled: !!repair_ticket_id && open
  });

  const forceClose = () => {
    setOpen(false);
    setSelectedTicket(null);
  }

  return (
    <Dialog
      title="View Repair Ticket"
      size="xl"
      forceOpen={open}
      forceClose={forceClose}
      saveFunc={() => {}}
    >
      <CardContent sx={{backgroundColor: theme.palette.background.default}} >
        <MainRepairView ticket={repair_ticket} dash={dash} />
      </CardContent>
    </Dialog>
  )
};

export default ViewRepairDialog;